export class LeaveData {
    
        constructor(public from?: string,
            public to?: string,
            public type?: string,
            public reason?: string,
            public status?: string) { }
    }


// WEBPACK FOOTER //
// /home/gideon/webbest/projects/wb-management-system/frontend/wb-management-system/src/app/assets/classes/leave-data.class.ts